import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { Grid, makeStyles } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import Link from '../../../components/link/Link'
import { WHITE } from '../../../theme'
import styles from '../../../styles'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { ResponsiveContext } from '../../../utils/context/responsiveContext'
import classnames from 'classnames'
import Loader from '../../../components/loader/Loader'
import { displayModal } from '../../reducers/modal/actions'
import { modalTypes } from '../../../enums/modalTypeEnum'
import EDLModal from '../edl/components/EDLModal'
import { EDLContext } from '../edl/context/EDLContext'

const useStyles = makeStyles<Theme, { isLargeScreen: boolean }>(
	(theme) => ({
		...styles(theme),
		preparezArriveeContainer: {
			margin: 0,
			marginBottom: 15
		},
		titleContainer: {
			...styles(theme).title3,
			margin: 0,
			marginBottom: props => props.isLargeScreen ? 18 : 22,
			fontSize: props => props.isLargeScreen ? 28 : 23,
			lineHeight: props => props.isLargeScreen ? '35px' : '29px'
		},
		blocContainer: {
			background: WHITE,
			padding: props => props.isLargeScreen ? '19px 55px 18px 21px' : '17px 61px 18px 21px',
			maxWidth: props => props.isLargeScreen ? '48%' : '100%',

			'& h2': {
				...styles(theme).title4,
				fontSize: props => props.isLargeScreen ? 16 : 13,
				lineHeight: props => props.isLargeScreen ? '24px' : '16px',
				color: theme.palette.blue.main,
				margin: 0
			},
			'& p': {
				...styles(theme).text17,
				color: theme.palette.blue.main,
				fontSize: props => props.isLargeScreen ? 13 : 12,
				lineHeight: props => props.isLargeScreen ? '20px' : '19px',
				margin: 0,
				marginTop: 12
			}
		},
		marginBloc: {
			marginBottom: 25
		},
		linkStyle: {
			marginTop: props => props.isLargeScreen ? 40 : 34
		},
		marginAssurance: {
			marginBottom: 'auto'
		}
	})
)

const PreparezDepart = () => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { shouldDisplayEdls, loading, isRdvEdlsPlanned, refresh, offre, idVisiteEdls, requete, dateCongesSouhaitee } = useContext(EDLContext)
	const classes = useStyles({ isLargeScreen })
	const dispatch = useDispatch()
	const user = useSelector((state: RootState) => state.user)

	if (!user) {
		return <></>
	}

	if (!shouldDisplayEdls) {
		return <></>
	}

	if (loading) {
		return (<Loader></Loader>)
	}

	return (
		<Grid container item xs={12} justify="space-between" className={classes.preparezArriveeContainer}>
			<Grid container item xs={12}>
				<h1 className={classes.titleContainer}>
					<FormattedMessage
						id="preparezDepart.titre"
						defaultMessage="Préparez votre départ"
						description="Titre du bloc Préparez votre départ"
					/>
				</h1>
			</Grid>
			<Grid container item xs={12} md={6} className={
				classnames(
					classes.blocContainer,
					classes.marginBloc
				)
			}>
				<Grid item xs={12}>
					<h2>
						<FormattedMessage
							id="preparezDepart.etatLieuxRemiseCles.titre"
							defaultMessage="Etat des lieux et remise des clés"
							description="Titre du bloc de Etat des lieux et remise des clés"
						/>
					</h2>
				</Grid>

				<Grid item xs={12}>
					<p>
						<FormattedMessage
							id={`preparezDepart.etatLieuxRemiseCles.${isRdvEdlsPlanned ? (requete?.jour1 ? 'texteRdvPlanifieCreneaux' :'texteRdvPlanifie') : 'texteRdvNonPlanifie'}`}
							defaultMessage="Votre YouFirst Manager fera l’état des lieux avec vous avant la remise des clés. Pensez à le contacter pour prendre le rendez-vous."
							description="Texte du bloc de Etat des lieux et remise des clés"
						/>
					</p>
				</Grid>
				<Grid item xs={12}>
					<Link
						color="colorAccessibility"
						textStyle="text4"
						className={classes.linkStyle}
						onClick={() => dispatch(displayModal(modalTypes.edls))}
					>
						<FormattedMessage
							id={`preparezDepart.etatLieuxRemiseCles.${isRdvEdlsPlanned ? 'ctaRdvPlanifie' : 'ctaRdvNonPlanifie'}`}
							defaultMessage="Transmettre l'attestation d'assurance"
							description="Titre du bloc de Partage d'assurance"
						/>
					</Link>
				</Grid>
			</Grid>
			{!!offre && requete?.id &&
				<EDLModal
					offre={offre}
					onValidate={() => refresh()}
					requete={requete}
					idVisiteEdl={idVisiteEdls}
					isEdls={true}
					dateEffetBail={null}
					dateCongesSouhaitee={dateCongesSouhaitee}
				/>
			}
		</Grid>
	)
}

export default PreparezDepart
